import {useQuery} from "@tanstack/react-query";
import {useAxiosPrivate} from "../useAxiosPrivate";

export default function usePlanQueries() {
    const axiosPrivate = useAxiosPrivate();

    // QUERIES ------------------------------------------------------

    const planListQuery = useQuery({
        queryKey: ["plans"],
        queryFn: () =>
            axiosPrivate
                .get("plans/")
                .then(r => r.data),
    });

    const usePlanQuery = (id) =>
        useQuery({
            queryKey: ["plans", id],
            queryFn: () =>
                axiosPrivate
                    .get(`plans/${id}/`)
                    .then(r => r.data),
            enabled: !!id,
        });

    // RETURN HOOKS ------------------------------------------------------

    return {
        planListQuery,
        usePlanQuery,
    };
}
